module.exports = __webpack_public_path__ + "img/icon_loan_up_amt.8f6e5da1.png";